import { httpRequest } from '../../../../app/common/util/api-common.util';

class CishAPI {
  static cancelamentoCish(laudo, justificativa) {
    return httpRequest(`laudos/${laudo}/etapas/cish/cancelamento`, 'PATCH', {
      justificativa: justificativa,
    }).then((json) => json.data);
  }
}

export default CishAPI;



// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/cish/cish.api.js